import axios from 'axios';

let globalUser: any = null;
let isUserContextReady = false;

const pendingRequests: Array<() => void> = [];

export const setAxiosUserContext = (user: any) => {
  globalUser = user;
  isUserContextReady = true;

  pendingRequests.forEach((resume) => resume());
  pendingRequests.length = 0;
};

const authServiceApiInstance = axios.create({
  baseURL: process.env.REACT_APP_AUTH_SERVICE_SERVER_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

authServiceApiInstance.interceptors.request.use(
  async (config) => {
    if (!isUserContextReady) {
      await new Promise<void>((resolve) => {
        pendingRequests.push(resolve);
      });
    }

    if (globalUser) {
      config.headers['x-company-code'] = globalUser.company_code;
      config.headers['x-financial-year'] = globalUser.financial_year;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default authServiceApiInstance;
